import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState, useRef  } from "react";

/* -------- packages -------- */
import { Container, Spinner } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { clearConfigurationErrors, fetchBrandsRequest, fetchCategoriesRequest, fetchComponentsRequest, fetchConfigurationRequest, fetchProjectsRequest, updateConfigurationRequest } from "../../store/actions";
/* ------------------------- */


/* -------- components -------- */
import Breadcrumb from "../../components/ui/Breadcrumbs";
import DynamicForm from "../../components/ui/Form";
import { intensity, protectionIndex } from '../../utils/items';
import { getErrorFromResponse } from '../../utils/utils';
import ErrorHandler from '../../components/ui/Error/ErrorHandler';
import IntensityModal from '../../components/ui/Modals/IntensityModal';
/* ------------------------- */


const ConfigurationNewEditPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams(); // Get the id from the URL
  const { configuration, loadingConfig, errorConfig, loadingCheckConfig } = useSelector(state => state.Configurations);
  const { loadingComponent } = useSelector(state => state.Components);
  const location = useLocation();
  const { projectId, isNewConfig } = location.state || {};
  
  const { projects } = useSelector(state => state.Projects);
  const [formattedProjects, setFormattedProjects] = useState([]);

  const brands = useSelector(state => state.Brands.brands);
  const components = useSelector(state => state.Components.components);
  const categories = useSelector(state => state.Categories.categories);

  const [formattedBrands, setFormattedBrands] = useState([]);
  const [alimentationTypes, setAlimentationTypes] = useState([]);
  const [ceeSocketTypes, setCeeSocketTypes] = useState([]);
  const [securityEquipments, setSecurityEquipments] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [electricalConnect, setElectricalConnectEquipments] = useState([]);
  const [formInitialValues, setFormInitialValues] = useState({});
  
  const [socketFields, setSocketFields] = useState([]);
  const [socketCount, setSocketCount] = useState(0);
  
  const ceeSocketTypesRef = useRef([]);
  
  const [formikInstance, setFormikInstance] = useState(null);
  
  const [configValues, setConfigValues] = useState(null);
  const [isIntensityModalOpen, setIsIntensityModalOpen] = useState(false);
  const [alertModal, setAlertModal] = useState(false);

  const handleConfigValues = (values) => {
    setConfigValues(values);
  }

  const handleFormikReady = (formikRef) => {
    setFormikInstance(formikRef);
  };

  useEffect(() => {
    if(id && !isNaN(id)){
      dispatch(fetchConfigurationRequest(id));
    }
    dispatch(fetchBrandsRequest());
    dispatch(fetchComponentsRequest());
    dispatch(fetchCategoriesRequest());
    dispatch(fetchProjectsRequest());
  }, [dispatch]);


  
  useEffect( () => {
    if(errorConfig?.data?.errors) {
      errorConfig?.data?.errors.forEach(err => {
        if (err.code == 'CONFIGURATION_LIMIT_EXCEEDED') {
          setAlertModal(true);
        } else if (err.code == 'INTENSITY_LIMIT_EXCEEDED') {
          setIsIntensityModalOpen(!isIntensityModalOpen);
        }
      });
    }
  }, [errorConfig]);
  ErrorHandler(errorConfig, clearConfigurationErrors);
  
  useEffect(() => {
    if (brands) {
      let newBrands = brands.map((brand) => {
        return {
          id: brand.id,
          label: brand.lib
        }
      });
      setFormattedBrands(newBrands);
    }
  }, [brands]);

  useEffect(() => {
    if (projects) {
      let newProjects = projects.map((project) => {
        return {
          id: project.id,
          label: project.lib
        }
      });
      setFormattedProjects(newProjects);
    }
  }, [projects]);

  useEffect(() => {
    if (components && categories) {
      const alimentationCategory = categories.find(cat => cat.lib === "Type d'alimentation");
      
      if (alimentationCategory && alimentationCategory.ProjComponents) {
        const alimentationComponents = alimentationCategory.ProjComponents.map(comp => (comp.lib));
        setAlimentationTypes(alimentationComponents);
      } 

      const ceeSocketCategory = categories.find(cat => cat.lib === "Prises CEE");
      
      if (ceeSocketCategory && ceeSocketCategory.ProjComponents) {
        //const ceeSocketComponents = ceeSocketCategory.ProjComponents.map(comp => (comp.lib)); 

        const sortById = ceeSocketCategory.ProjComponents.map(comp => comp)?.sort((a, b) => a.id - b.id)?.map(comp => comp.lib);
        setCeeSocketTypes(sortById);
        ceeSocketTypesRef.current = sortById;

      }

      const securityCategory = categories.find(cat => cat.lib === "Equipements de sécurité");
      
      if (securityCategory && securityCategory.ProjComponents) {
        const securityComponents = securityCategory.ProjComponents.map(comp => (comp.lib)).filter((securityEquipment) => securityEquipment != "Arret d'urgence");
        setSecurityEquipments(securityComponents);
      }

      const electricalConnectCategory = categories.find(cat => cat.lib === "Raccordement");
      
      if (electricalConnectCategory && electricalConnectCategory.ProjComponents) {
        const electricalConnectComponents = electricalConnectCategory.ProjComponents.map(comp => (comp.lib));
        setElectricalConnectEquipments(electricalConnectComponents);
      }

      const accessoriesCategory = categories.find(cat => cat.lib === "Accessoires");
      
      if (accessoriesCategory && accessoriesCategory.ProjComponents) {
        const accessoriesComponents = accessoriesCategory.ProjComponents.map(comp => (comp.lib)); 
        setAccessories(accessoriesComponents);
      }
    }
  }, [components, categories]);

  useEffect(() => {
    if (location.state?.projectId && projects.length > 0) {
      const selectedProject = projects.find(project => project.id === location.state.projectId);
      if (selectedProject) {
        setFormInitialValues({
          projectId: selectedProject.id,
          lib: '',  // autres champs avec valeurs par défaut
          status: 'PENDING',
          reference: 'GBB000000'
        });
      }
    }
  }, [location.state, projects]);

  useEffect(() => {
  }, [ceeSocketTypes]);

  const handleAddSocket = (index = null) => {
    const newIndex = (index && !isNaN(index)) ? index : socketCount + 1;
    
    // Vérifier si les champs pour cet index existent déjà
    const existingFields = socketFields.some(field => 
      field.groupIndex === newIndex && field.groupName === 'ceeSocket'
    );
    
    if (existingFields) {
      return; // Ne pas ajouter si les champs existent déjà
    }
    
    setSocketCount(prevCount => Math.max(prevCount, newIndex));

    const newFields = [
      { 
        key: `ceeSocketType${newIndex}`, 
        type: 'select',  
        options: ceeSocketTypesRef.current, 
        required: true, 
        isInJson: "configElectricalOutlets",
        label: t('ceeSocketType') + ` ${newIndex}`,
        groupIndex: newIndex,
        groupName: 'ceeSocket'
      },
      { 
        key: `nbCeeSocket${newIndex}`, 
        type: 'number', 
        required: true, 
        min: 1,
        isInJson: "configElectricalOutlets",
        label: t('nbCeeSocket') + ` ${newIndex}`,
        groupIndex: newIndex,
        groupName: 'ceeSocket'
      }
    ];

    setSocketFields(prev => [...prev, ...newFields]);
  };

  const handleRemoveGroup = (groupName, indexToRemove) => {
    if (groupName === 'ceeSocket' && formikInstance) {
      const currentValues = formikInstance.values || {};
      
      // Extraire les valeurs depuis configElectricalOutlets JSON
      let configElectricalOutlets = {};
      if (currentValues.configElectricalOutlets) {
        configElectricalOutlets = typeof currentValues.configElectricalOutlets === 'string' 
          ? JSON.parse(currentValues.configElectricalOutlets)
          : currentValues.configElectricalOutlets;
      }
      
      // Filtrer les champs qui ne sont pas supprimés
      const remainingFields = socketFields.filter(field => 
        !(field.groupIndex === indexToRemove && field.groupName === groupName)
      );
      
      // Obtenir tous les index existants triés
      const existingIndexes = [...new Set(
        remainingFields
          .filter(field => field.groupName === groupName)
          .map(field => field.groupIndex)
      )].sort((a, b) => a - b);
      
      // Créer les nouveaux champs et valeurs
      const reindexedFields = [];
      const newValues = { ...currentValues };
      
      // Supprimer les valeurs des champs supprimés du JSON
      delete configElectricalOutlets[`ceeSocketType${indexToRemove}`];
      delete configElectricalOutlets[`nbCeeSocket${indexToRemove}`];
      
      // D'abord, récupérer toutes les valeurs existantes dans l'ordre des index
      const existingData = [];
      existingIndexes.forEach((oldIndex) => {
        existingData.push({
          socketType: configElectricalOutlets[`ceeSocketType${oldIndex}`] || currentValues[`ceeSocketType${oldIndex}`],
          nbSocket: configElectricalOutlets[`nbCeeSocket${oldIndex}`] || currentValues[`nbCeeSocket${oldIndex}`]
        });
      });
      
      // Nettoyer toutes les anciennes valeurs des champs CEE socket du JSON
      Object.keys(configElectricalOutlets).forEach(key => {
        if (key.startsWith('ceeSocketType') || key.startsWith('nbCeeSocket')) {
          delete configElectricalOutlets[key];
        }
      });
      
      // Nettoyer aussi les valeurs directes dans formik (au cas où)
      Object.keys(newValues).forEach(key => {
        if (key.startsWith('ceeSocketType') || key.startsWith('nbCeeSocket')) {
          delete newValues[key];
        }
      });
      
      // Recréer les champs et valeurs avec les nouveaux index
      existingData.forEach((data, position) => {
        const newIndex = position + 1; // Les nouveaux index commencent à 1
        
        // Créer les nouveaux champs
        reindexedFields.push(
          {
            key: `ceeSocketType${newIndex}`,
            type: 'select',
            options: ceeSocketTypesRef.current,
            required: true,
            isInJson: "configElectricalOutlets",
            label: t('ceeSocketType') + ` ${newIndex}`,
            groupIndex: newIndex,
            groupName: 'ceeSocket'
          },
          {
            key: `nbCeeSocket${newIndex}`,
            type: 'number',
            required: true,
            min: 1,
            isInJson: "configElectricalOutlets",
            label: t('nbCeeSocket') + ` ${newIndex}`,
            groupIndex: newIndex,
            groupName: 'ceeSocket'
          }
        );
        
        // Assigner les valeurs dans le JSON ET dans formik values
        configElectricalOutlets[`ceeSocketType${newIndex}`] = data.socketType;
        configElectricalOutlets[`nbCeeSocket${newIndex}`] = data.nbSocket;
        newValues[`ceeSocketType${newIndex}`] = data.socketType;
        newValues[`nbCeeSocket${newIndex}`] = data.nbSocket;
      });
      
      // Mettre à jour le JSON dans les valeurs
      newValues.configElectricalOutlets = JSON.stringify(configElectricalOutlets);
      
      // Mettre à jour les états
      setSocketFields(reindexedFields);
      setSocketCount(reindexedFields.length / 2);
      
      // Mettre à jour les valeurs du formulaire
      formikInstance.setValues(newValues);
    }
  };

  const getDisposition = () => {
    const baseDisposition = [
      ['projectId', 'lib'],
      ['quantity', 'protectionIndex'],
      ['electricalConnect', 'brandId'],
      ['powerSupply', 'powerSupplyIntensity'],
      ['nbCircuitBreakers', 'nbElectricalOutlets'],
      ['addSocket', '']
    ];

    // Grouper les champs par groupe et index
    const groupsByNameAndIndex = {};
    socketFields.forEach(field => {
      if (field.groupIndex && field.groupName) {
        const key = `${field.groupName}_${field.groupIndex}`;
        if (!groupsByNameAndIndex[key]) {
          groupsByNameAndIndex[key] = [];
        }
        groupsByNameAndIndex[key].push(field.key);
      }
    });

    // Ajouter chaque ligne de groupe
    Object.keys(groupsByNameAndIndex).forEach(groupKey => {
      const fieldsInGroup = groupsByNameAndIndex[groupKey];
      if (fieldsInGroup.length >= 2) {
        baseDisposition.push(fieldsInGroup);
      }
    });

    baseDisposition.push(['safetyEquipment', 'accessories']);

    return baseDisposition;
  };

  const getGroupedRows = () => {
    const groupsByNameAndIndex = {};
    socketFields.forEach(field => {
      if (field.groupIndex && field.groupName) {
        const key = `${field.groupName}_${field.groupIndex}`;
        if (!groupsByNameAndIndex[key]) {
          groupsByNameAndIndex[key] = {
            groupName: field.groupName,
            groupIndex: field.groupIndex,
            fields: []
          };
        }
        groupsByNameAndIndex[key].fields.push(field.key);
      }
    });
    
    return Object.values(groupsByNameAndIndex).filter(group => group.fields.length >= 2);
  };

  useEffect(() => {
    if(id==configuration?.id){
      if (configuration?.configElectricalOutlets) {
        const electricalOutlets = typeof configuration.configElectricalOutlets === 'string' 
            ? JSON.parse(configuration.configElectricalOutlets)
            : configuration.configElectricalOutlets;
          
          // Récupérer le nombre de prises existantes
          const existingSocketCount = Object.keys(electricalOutlets)
            .filter(key => key.startsWith('ceeSocketType'))
            .length;
          // Créer les champs pour chaque prise existante
          for (let i = 1; i <= existingSocketCount; i++) {
            if((id && !isNaN(id)) && ceeSocketTypes && ceeSocketTypes.length > 0 ){
              handleAddSocket(i);
            }
          }
      }
    } 
    
  }, [configuration, ceeSocketTypes]);


  const [fields, setFields] = useState([
    { key: 'projectId', type: 'select', options: formattedProjects, required: true},
    { key: 'lib', type: 'text', required: true, label: t('configurationName')},
    { key: 'quantity', type: 'number', required: true},
    { key: 'protectionIndex', type: 'select', options: protectionIndex, required: true},
    { key: 'electricalConnect', type: 'select', options: electricalConnect, required: true},
    { key: 'brandId', type: 'select', options: formattedBrands, required: false},
    { key: 'powerSupply', type: 'select', options: alimentationTypes, required: true},
    { key: 'powerSupplyIntensity', type: 'select', options: intensity, required: true},
    { key: 'nbCircuitBreakers', type: 'number', required: true },
    { key: 'nbElectricalOutlets', type: 'number', required: true },
    { key: 'addSocket', type: 'button', label: t('addSocketType'), onClick: handleAddSocket},
    ...socketFields,
    { key: 'safetyEquipment', type: 'select', options: securityEquipments, required: true},
    { key: 'accessories', type: 'select', options: accessories, required: true},
    { key: 'status', type: 'select', defaultValue: "PENDING", required: true, noShow: true},
    { key: 'reference', type: 'text', defaultValue: "GBB000000", required: true, noShow: true},
  ]);   



  useEffect(() => {
    setFields ([
      { key: 'projectId', type: 'select', options: formattedProjects, required: true},
      { key: 'lib', type: 'text', required: true, label: t('configurationName')},
      { key: 'quantity', type: 'number', required: true},
      { key: 'protectionIndex', type: 'select', options: protectionIndex, required: true},
      { key: 'electricalConnect', type: 'select', options: electricalConnect, required: true},
      { key: 'brandId', type: 'select', options: formattedBrands, required: false},
      { key: 'powerSupply', type: 'select', options: alimentationTypes, required: true},
      { key: 'powerSupplyIntensity', type: 'select', options: intensity, required: true},
      { key: 'nbCircuitBreakers', type: 'number', required: true },
      { key: 'nbElectricalOutlets', type: 'number', required: true },
      { key: 'addSocket', type: 'button', label: t('addSocketType'), onClick: handleAddSocket},
      ...socketFields,
      { key: 'safetyEquipment', type: 'select', options: securityEquipments, required: true},
      { key: 'accessories', type: 'select', options: accessories, required: true},
      { key: 'status', type: 'select', defaultValue: "PENDING", required: true, noShow: true},
      { key: 'reference', type: 'text', defaultValue: "GBB000000", required: true, noShow: true},
    ])   
  }, [socketFields, formattedBrands, alimentationTypes, electricalConnect, protectionIndex, intensity]);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    const status = document.getElementById("status");

    if (loadingConfig) {
      if (preloader) preloader.style.display = "block";
      if (status) status.style.display = "block";
    } else {
      if (preloader) preloader.style.display = "none";
      if (status) status.style.display = "none";
    }
  }, [loadingConfig]);

  return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={t("configurations")} breadcrumbItem={t("configurations")} url={'/configurations'} />
          <DynamicForm
            fields={fields} 
            initialValues={id && !isNaN(id) ? (configuration || {}) : formInitialValues} 
            editFunction={updateConfigurationRequest}
            isEdit={id}
            isLoading={loadingConfig || loadingComponent || loadingCheckConfig}
            error={errorConfig} // Pass the error to DynamicForm
            prefListName={"configuration"}
            disposition={getDisposition()}
            isConfig={true}
            groupedRows={getGroupedRows()}
            onRemoveGroup={handleRemoveGroup}
            onFormikReady={handleFormikReady} 
            submitAndNavigatBtn={true}
            submitAndNavigatLabel={'submitAndNavigateConfig'}
            handleReturnValues={handleConfigValues}
          />
        </Container>
          <Modal isOpen={alertModal} toggle={() => setAlertModal(false)}>
            <ModalHeader toggle={() => setAlertModal(false)}>
              {t("attention")}
            </ModalHeader>
            <ModalBody>
              {t("maxAmperesExceeded").split('\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}
            </ModalBody>
            <ModalFooter>
              <Button color="primary"onClick={() => {
                  setAlertModal(false);
                }}>
                {t("OK")}
              </Button>
            </ModalFooter>
          </Modal>
          <IntensityModal isModalOpen={isIntensityModalOpen} setModalOpen={setIsIntensityModalOpen} config={configValues}/>
        <ToastContainer />
      </div>
  );
};

export default ConfigurationNewEditPage;